//@flow
import React, { Component } from "react";
import type { ProductType } from "../types/product.js";

type Props = {
  product: ProductType
};

class ListItemIdentity extends Component<Props> {
  render() {
    let productData: ProductType = this.props.product;

    return (
      <div className="wishlist-tile__product-identity">
        <a
          href={productData.productDetailsUrl}
          className="wishlist-tile__product-name"
        >
          {productData.title}
        </a>
        <span className="wishlist-tile__product-code">
          Product code: {productData.productCode}
        </span>
      </div>
    );
  }
}

export default ListItemIdentity;
